mutation UpdateChatOverlayYouTubeChannels($chatId: ID!, $youtubeChatChannels: [String!]!) {
  chat: StreamToolsUpdateChatOverlay(chatId: $chatId, youtubeChatChannels: $youtubeChatChannels) {
    chatId
    name
    twitchChatChannels
    showTextShadow
    textShadow
    showBadges
    showChannelPills
    usernameFontSize
    usernameLineHeight
    messageFontSize
    messageLineHeight
    messageFontWeight
    usernameFontWeight
    imageScale
    messageColor
    blockedWords
    fontFamily
    youtubeSourceEnabled
    youtubeChatChannels
    chatDelayMs
    width
    height
    show7tvEmotes
    showBttvEmotes
    showFfzEmotes
    showYouTubeProfilePictures
    createdAt
  }
}
